<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm" *ngIf="formData">
  <div class="relative w-full max-w-2xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col max-h-[90vh]">

    <div *ngIf="isLoadingDetail() || isSaving()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">confirmation_number</span>
          {{ advanceId > 0 ? 'แก้ไข Advance (โควต้า)' : 'สร้าง Advance (โควต้า)' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">เลือกร้าน → เลือกโควต้า → ประเภทรถ → จำนวนรหัส</p>
        <div *ngIf="formData.clientId > 0 && hasUsableQuotaRemaining"
          class="mt-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-xl text-xs font-bold bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400">
          <span class="material-icons text-sm">account_balance_wallet</span>
          สร้างรหัสได้รวม {{ totalQuotaRemaining }} รายการ
        </div>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar space-y-5">
      <!-- ① ร้าน -->
      <app-pss-searchable-picker
        label="ร้าน / Client"
        icon="store"
        placeholder="ค้นหาชื่อร้าน..."
        [required]="true"
        [disabled]="isClientFieldLocked || isSaving()"
        [selectedId]="formData.clientId || null"
        [displayText]="formData.clientName"
        [options]="clientPickerOptions()"
        [total]="clientPickerTotal()"
        [loading]="false"
        (opened)="onClientPickerOpened()"
        (searchChange)="onClientPickerSearch($event)"
        (optionSelected)="onClientPickerSelected($event)"
        (cleared)="onClientPickerCleared()">
      </app-pss-searchable-picker>

      <!-- ② เลือกโควต้าจากรายการ -->
      <div *ngIf="requiresClientFirst"
        class="p-5 rounded-2xl border border-dashed border-amber-300 dark:border-amber-700 bg-amber-50/40 dark:bg-amber-900/10 text-center">
        <span class="material-icons text-3xl text-amber-500 mb-2">store</span>
        <p class="text-sm font-bold text-amber-800 dark:text-amber-300">กรุณาเลือกร้านก่อน</p>
        <p class="text-xs text-amber-700/80 dark:text-amber-400/80 mt-1">ระบบจะแสดงรายการโควต้าให้เลือก แล้วจึงเลือกประเภทรถ</p>
      </div>

      <div *ngIf="canShowQuotaList" class="space-y-3">
        <div *ngIf="isLoadingQuotaSummary()"
          class="p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 flex items-center gap-3 text-sm text-slate-500">
          <div class="w-5 h-5 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
          กำลังโหลดโควต้าของร้าน...
        </div>

        <div *ngIf="!isLoadingQuotaSummary() && quotaSummaryItems.length > 0"
          class="p-5 rounded-2xl border border-emerald-200/70 dark:border-emerald-800/50 bg-emerald-50/50 dark:bg-emerald-900/20">
          <h4 class="text-sm font-bold text-emerald-800 dark:text-emerald-300 flex items-center gap-2 mb-1">
            <span class="material-icons text-base">touch_app</span>
            เลือกโควต้า — {{ formData.clientName }}
          </h4>
          <p class="text-[11px] text-emerald-700/80 dark:text-emerald-400/80 mb-4">คลิกโควต้าที่ต้องการใช้ (ต้องมีคงเหลือ &gt; 0)</p>

          <div class="space-y-2 max-h-56 overflow-y-auto custom-scrollbar">
            <button type="button" *ngFor="let q of quotaSummaryItems"
              (click)="onQuotaFromListSelected(q)"
              [disabled]="q.quotaRemaining <= 0 || isSaving()"
              class="w-full text-left p-3 rounded-xl border grid grid-cols-2 md:grid-cols-4 gap-2 text-sm transition-all"
              [ngClass]="isQuotaSelected(q)
                ? 'bg-amber-50 dark:bg-amber-900/30 border-amber-400 dark:border-amber-600 ring-2 ring-amber-200 dark:ring-amber-700/50'
                : q.quotaRemaining > 0
                  ? 'bg-white/80 dark:bg-slate-800/80 border-slate-100 dark:border-slate-700 hover:border-amber-300 dark:hover:border-amber-700 cursor-pointer'
                  : 'bg-slate-50 dark:bg-slate-800/50 border-slate-100 dark:border-slate-700 opacity-50 cursor-not-allowed'">
              <div class="md:col-span-2 flex items-start gap-2">
                <span *ngIf="isQuotaSelected(q)" class="material-icons text-amber-500 text-lg shrink-0">check_circle</span>
                <div>
                  <div class="text-xs text-slate-400 font-bold uppercase">โควต้า</div>
                  <div class="font-bold text-slate-800 dark:text-slate-100">{{ q.name }}</div>
                  <div class="text-[11px] text-slate-400">{{ q.cardScope || '-' }}</div>
                </div>
              </div>
              <div>
                <div class="text-xs text-slate-400 font-bold uppercase">อนุมัติ / ใช้</div>
                <div class="font-bold text-slate-700 dark:text-slate-200">{{ q.quotaApproved }} / {{ q.quotaUsed }}</div>
                <span class="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-700 text-slate-500">{{ quotaLevelLabel(q.quotaLevel) }}</span>
              </div>
              <div class="text-right">
                <div class="text-xs font-bold uppercase"
                  [ngClass]="q.quotaRemaining > 0 ? 'text-emerald-600' : 'text-rose-600'">คงเหลือ</div>
                <div class="text-xl font-black"
                  [ngClass]="q.quotaRemaining > 0 ? 'text-emerald-700 dark:text-emerald-400' : 'text-rose-600'">
                  {{ q.quotaRemaining }}
                </div>
              </div>
            </button>
          </div>

          <p *ngIf="!hasUsableQuotaRemaining" class="text-xs text-rose-600 dark:text-rose-400 mt-3 flex items-center gap-1">
            <span class="material-icons text-sm">error</span> โควต้าหมดแล้ว — ไม่สามารถสร้าง Advance ได้
          </p>
        </div>
      </div>

      <!-- ③ ประเภทรถ (หลังเลือกโควต้า) -->
      <ng-container *ngIf="selectedQuotaRow">
        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            ประเภทรถ <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">directions_car</span>
            <select [(ngModel)]="formData.vehicleTypeId" (ngModelChange)="onVehicleTypeChange()"
              [disabled]="!canPickVehicleType || isSaving() || vehicleTypes.length === 0"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-60">
              <option [ngValue]="0">-- เลือกประเภทรถ --</option>
              <option *ngFor="let vt of vehicleTypes" [ngValue]="vt.id">{{ vt.name }}</option>
            </select>
          </div>
          <p class="text-[11px] text-slate-400 mt-1">จาก whitelist ประเภทบัตร Platform (path 51)</p>
        </div>

        <!-- รายละเอียดประเภทบัตร (หลังเลือกรถ) -->
        <div *ngIf="formData.vehicleTypeId > 0 && (isResolvingCard() || resolvedCard)"
          class="p-4 rounded-2xl border border-amber-100 dark:border-amber-900/30 bg-amber-50/50 dark:bg-amber-900/10 grid grid-cols-2 gap-3 text-sm">
          <div *ngIf="isResolvingCard()" class="col-span-2 flex items-center gap-2 text-slate-500 text-xs">
            <div class="w-4 h-4 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
            กำลังโหลดประเภทบัตรจาก whitelist...
          </div>
          <ng-container *ngIf="!isResolvingCard() && resolvedCard">
            <div>
              <div class="text-xs text-slate-400 uppercase font-bold">ประเภทบัตร (จาก whitelist Platform)</div>
              <div class="font-bold text-slate-800 dark:text-slate-100">{{ resolvedCard.cardTypeName }}</div>
            </div>
            <div>
              <div class="text-xs text-slate-400 uppercase font-bold">Subscription</div>
              <div class="font-bold text-slate-800 dark:text-slate-100">{{ resolvedCard.subscriptionName || '-' }}</div>
            </div>
            <div>
              <div class="text-xs text-slate-400 uppercase font-bold">โควต้าที่เลือก</div>
              <div class="font-bold text-slate-800 dark:text-slate-100">{{ selectedQuotaRow.name }}</div>
            </div>
            <div>
              <div class="text-xs text-slate-400 uppercase font-bold">คงเหลือออกได้</div>
              <div class="font-black text-emerald-600 text-lg">{{ selectedQuotaRow.quotaRemaining }}</div>
            </div>
          </ng-container>
        </div>

        <!-- ④ จำนวน + วันที่ -->
        <div *ngIf="formData.vehicleTypeId > 0 && resolvedCard" class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
              จำนวนรหัส activate <span class="text-rose-500">*</span>
            </label>
            <input type="number" min="1" [max]="maxQty || 1" [(ngModel)]="formData.qty"
              (ngModelChange)="onQtyChange()" (input)="onQtyInput($event)"
              [disabled]="!canEditQty || isSaving()"
              class="w-full h-[46px] px-4 rounded-xl border text-sm font-medium focus:outline-none focus:ring-2 disabled:opacity-60"
              [ngClass]="qtyExceedsQuota
                ? 'border-rose-400 bg-rose-50/50 dark:bg-rose-900/10 focus:ring-rose-200'
                : 'border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 focus:ring-amber-200'">
            <p *ngIf="canEditQty" class="text-[11px] text-slate-400 mt-1">สูงสุด {{ maxQty }} รายการ (ตามโควต้าคงเหลือ)</p>
            <p *ngIf="qtyExceedsQuota" class="text-[11px] text-rose-600 dark:text-rose-400 mt-1">
              จำนวนเกินโควต้าคงเหลือ — กรุณาไม่เกิน {{ maxQty }}
            </p>
          </div>
          <div></div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">วันเริ่มบัตร</label>
            <input type="date" [(ngModel)]="formData.startDate" [disabled]="!canEditQtyAndDates || isSaving()"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60">
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">วันหมดอายุ</label>
            <input type="date" [(ngModel)]="formData.endDate" [disabled]="!canEditQtyAndDates || isSaving()"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60">
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
              รหัสใช้ได้ภายใน (วัน) <span class="text-rose-500">*</span>
            </label>
            <input type="number" min="1" max="365" [(ngModel)]="formData.activateExpireDays"
              [disabled]="!canEditQtyAndDates || isSaving()"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60">
            <p class="text-[11px] text-slate-400 mt-1">นับจากวัน Gen — default 10 วัน · หมดอายุแล้ว activate ไม่ได้</p>
          </div>
        </div>

        <div *ngIf="formData.vehicleTypeId > 0 && resolvedCard">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
          <textarea [(ngModel)]="formData.remark" rows="2" [disabled]="isSaving()"
            class="w-full px-4 py-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
        </div>
      </ng-container>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-end gap-3">
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        ยกเลิก
      </button>
      <button type="button" (click)="onSaveDraft()" [disabled]="!canSave"
        class="px-5 py-2.5 rounded-xl border border-amber-200 dark:border-amber-800 font-bold text-amber-700 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors disabled:opacity-50">
        บันทึก Draft
      </button>
      <button type="button" (click)="onSubmitApproval()" [disabled]="!canSave"
        class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50">
        {{ isSaving() ? 'กำลังบันทึก...' : 'ส่งอนุมัติ' }}
      </button>
    </div>
  </div>
</div>
